import {
  GET_SEGMENT,
  UPDATE_SEGMENT_SAGA,
  DELETE_SEGMENT_SAGA
} from './actionsTypes';

const actions = {
  initData: () => ({ type: GET_SEGMENT }),
  updateSegment: segment => {
    return (dispatch, getState) => {
      const segments = getState().Segments.segments;
      const index = segments.map(inv => inv._id).indexOf(segment._id);

      if (index === -1) {
        segments.unshift(segment);
      } else {
        segments[index] = segment;
      }

      dispatch({
        type: UPDATE_SEGMENT_SAGA,
        segments,
        segment,
      });
    };
},
  deleteSegment: id => {
      return (dispatch, getState) => {
        const segments = getState().Segments.segments;
        const newSegments = [];
        segments.forEach(segment => {
          if (segment._id !== id) {
            newSegments.push(segment);
          }
        });
        dispatch({
          type: DELETE_SEGMENT_SAGA,
          segments: newSegments,
          segment: id,
        });
      };
  },
};

export default actions;